import { IconProps } from './icon';

export function IconPlay({
  size = '100%',
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 86 86"
      fill="none"
    >
      <path
        d="M0 43C0 19.2523 19.2523 0 43 0C66.7477 0 86 19.2523 86 43C86 66.7477 66.7477 86 43 86C19.2523 86 0 66.7477 0 43ZM43 5.86364C33.1508 5.86364 23.705 9.77621 16.7406 16.7406C9.77621 23.705 5.86364 33.1508 5.86364 43C5.86364 52.8492 9.77621 62.295 16.7406 69.2594C23.705 76.2238 33.1508 80.1364 43 80.1364C52.8492 80.1364 62.295 76.2238 69.2594 69.2594C76.2238 62.295 80.1364 52.8492 80.1364 43C80.1364 33.1508 76.2238 23.705 69.2594 16.7406C62.295 9.77621 52.8492 5.86364 43 5.86364Z"
        fill={fill}
      />
      <path
        d="M0 30.0403V1.95576C0.00059006 1.60438 0.0965366 1.25962 0.277789 0.957611C0.459041 0.655604 0.718926 0.407467 1.03021 0.239205C1.34149 0.070943 1.69271 -0.01125 2.04706 0.00123777C2.40141 0.0137255 2.74585 0.120433 3.04428 0.310182L25.0896 14.3485C25.3688 14.5258 25.5985 14.7697 25.7575 15.058C25.9166 15.3462 26 15.6695 26 15.998C26 16.3266 25.9166 16.6498 25.7575 16.9381C25.5985 17.2263 25.3688 17.4703 25.0896 17.6475L3.04428 31.6898C2.74585 31.8796 2.40141 31.9863 2.04706 31.9988C1.69271 32.0113 1.34149 31.9291 1.03021 31.7608C0.718926 31.5925 0.459041 31.3444 0.277789 31.0424C0.0965366 30.7404 0.00059006 30.3956 0 30.0442V30.0403Z"
        fill={fill}
        transform="translate(34, 26)"
      />
    </svg>
  );
}
